<script setup lang="ts">
defineOptions({ inheritAttrs: false });

const { mapbox: mapboxAllowed } = useCookieConsent();
</script>

<template>
  <AppStaticMap :mapbox-allowed="mapboxAllowed" v-bind="$attrs">
    <template #disabled>
      <WebCookieConsentMapPlaceholder />
    </template>
    <slot />
  </AppStaticMap>
</template>
